// --ManageClients.jsx

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import PaginatedTable from "../components/library/Pagination";
import Loader from "../components/common/Loader";
import API_BASE_URL from "../config/api";

const ManageClients = ({ onNewClient }) => {
    const token = sessionStorage.getItem("token");
    const navigate = useNavigate();
    const [clients, setClients] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);

    // Fetch clients from API
    useEffect(() => {
        const fetchClients = async () => {
            try {
                setLoading(true);
                const res = await axios.get(`${API_BASE_URL}/api/Clients`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setClients(res.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchClients();
    }, [token]);

    const filteredClients = clients.filter((c) =>
        c.clientName.toLowerCase().includes(search.toLowerCase())
    );


    return (
        <>
            {loading ? (
                <Loader message="Loading..." />
            ) : (
                <div className="relative flex min-h-screen flex-col bg-white group/design-root overflow-x-hidden">
                    <div className="layout-container flex h-full grow flex-col">
                        <div className="flex flex-1 justify-center pb-5">
                            <div className="layout-content-container flex flex-col flex-1">
                                <div className="flex flex-wrap justify-between gap-3 p-4">
                                    <p className="text-[#111418] tracking-light text-[32px] font-bold leading-tight min-w-72">
                                        Clients
                                    </p>
                                    <Link to="/app/addnewclient">
                                        <button className="custom-btn">
                                            <span className="truncate">+ Add Client</span>
                                        </button>
                                    </Link>
                                </div>

                                {/* Search */}
                                {/* <div className="px-4 py-3">
                                    <label className="flex min-w-40 h-12">
                                        <div className="flex items-center rounded-lg bg-[#f0f2f5] w-80"> 
                                         
                                            <div className="flex items-center justify-center px-3 text-[#60758a]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    fill="currentColor"
                                                    viewBox="0 0 256 256"
                                                >
                                                    <path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path>
                                                </svg>
                                            </div>

                                     
                                            <input
                                                type="text"
                                                placeholder="Search clients name"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className="flex-1 h-full border-none bg-transparent text-[#111418] placeholder:text-[#60758a] text-base font-normal leading-normal focus:outline-none px-2"
                                            />
                                        </div>
                                    </label>
                                </div> */}

                                <input
                                    type="text"
                                    placeholder="Search clients name"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="form-input rounded-xl border h-14 p-3 mx-4 max-w-[250px]"
                                />

                                {/* Table */}
                                <div className="px-4 py-3 @container">
                                    <div className="flex overflow-hidden rounded-xl border border-[#dde1e3] bg-white">
                                        <PaginatedTable
                                            columns={[
                                                "Client Name",
                                                "Contact",
                                                "Email",
                                                "Phone",
                                                "Actions",
                                            ]}
                                            data={filteredClients}
                                            pageSize={10}
                                            renderRow={(client, index) => (
                                                <tr
                                                    key={client.id}
                                                    className={`border-t border-t-[#dde1e3] ${!client.status ? "bg-red-50 text-red-600" : ""
                                                        }`}
                                                >
                                                    <td className="h-[72px] px-4 py-2 w-[400px] text-[#111418] text-sm font-normal leading-normal">
                                                        {client.clientName}
                                                    </td>
                                                    <td className="h-[72px] px-4 py-2 w-[400px] text-[#60758a] text-sm font-normal leading-normal">
                                                        {client.contactPerson}
                                                    </td>
                                                    <td className="h-[72px] px-4 py-2 w-[400px] text-[#60758a] text-sm font-normal leading-normal">
                                                        {client.email}
                                                    </td>
                                                    <td className="h-[72px] px-4 py-2 w-[400px] text-[#60758a] text-sm font-normal leading-normal">
                                                        {client.phoneNumber}
                                                    </td>
                                                    <td className="h-[72px] text-sm font-normal leading-normal flex content-center gap-4 p-4">
                                                        <button onClick={() => navigate(`/app/clientdetails/${client.id}`)} className="btn-black">
                                                            <span className="truncate">View</span>
                                                        </button>

                                                        <Link
                                                            to={`/app/addnewclient/${client.id}`}
                                                            className="custom-btn"
                                                        >
                                                            <span className="truncate">Edit</span>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ManageClients;
